import { client } from '..';
import {
  DonateToNpoParams,
  DonationImpactResponse,
  UserImpactMapResponse,
  UserImpactResponse,
  UserImpactScrollingResponse
} from '../models/donationModels';

export const donateToNpo = async ({
  nonProfitOrgId,
  giftType,
  optIn,
  amount,
  cardKey,
  checkKey,
  contract,
  surcharge,
  notes
}: DonateToNpoParams) => {
  const { data } = await client.post('/donations/donate', {
    nonProfitOrgId,
    giftType,
    optIn,
    amount,
    cardKey,
    checkKey,
    contract,
    surcharge,
    notes
  });

  return data;
};

export const userImpact = async ({
  npoType,
  periodTime
}: {
  npoType: string;
  periodTime: string;
}): Promise<UserImpactResponse> => {
  const { data } = await client.get(`/users/impact?npoType=${npoType}&periodTime=${periodTime}`);
  return data;
};

export const userImpactMap = async ({
  polygon,
  limit = 25,
  npoType
}: {
  polygon: string[];
  limit?: number;
  npoType?: 'church' | 'charity';
}): Promise<UserImpactMapResponse[]> => {
  const url = `/users/impact-map?polygon=${'[' + polygon + ']'}&limit=${limit}${npoType !== undefined ? `&npoType=${npoType}` : ''}`;

  const { data } = await client.get(url);

  return data;
};

export const userImpactScrolling = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | number | undefined)[];
  pageParam: string;
}): Promise<UserImpactScrollingResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, n, limit, npoType, periodTime] = queryKey;

  const url = `/users/impact-scrolling?n=${pageParam}&limit=${limit}&npoType=${npoType}&periodTime=${periodTime}`;

  const { data } = await client.get(url);

  return data;
};

export const donationImpact = async ({ userId }: { userId: string }): Promise<DonationImpactResponse> => {
  const { data } = await client.get(`/donations/impact/${userId}`);
  return data;
};

export const contactNpoRefund = async ({
  transactionId,
  email,
  reason
}: {
  transactionId: string;
  email: string;
  reason: string;
}): Promise<any> => {
  const { data } = await client.post(`/donations/transactions/${transactionId}/refund/email-request`, {
    email,
    reason
  });
  return data;
};
